import { ChangeEvent } from 'react';
import { createAction } from 'typesafe-actions';

import { ECompanyType } from 'shared/repositories/coworking/entities/api/PublicationRequestSchema';

import { EPlacementApplicationFormFields, EValidateActionTypes } from './constants';

const onChangeInputCallback = (event: ChangeEvent<HTMLInputElement>): string => event.target.value;
const onChangePhoneInputCallback = (value: string): string => value;

export const setPhoneFieldValueAction = createAction(
  EPlacementApplicationFormFields.Phone,
  onChangePhoneInputCallback,
)<string>();
export const setEmailFieldValueAction = createAction(
  EPlacementApplicationFormFields.Email,
  onChangeInputCallback,
)<string>();
export const setCompanyNameFieldValueAction = createAction(
  EPlacementApplicationFormFields.CompanyName,
  onChangeInputCallback,
)<string>();
export const setCompanyTypeFieldValueAction = createAction(EPlacementApplicationFormFields.CompanyType)<ECompanyType>();

export const validateAllAction = createAction(EValidateActionTypes.ValidateAll)();
export const validateByFieldAction = createAction(
  EValidateActionTypes.ValidateByField,
)<EPlacementApplicationFormFields>();
